// 🚨 GENERATED FILE - DO NOT EDIT DIRECTLY
export enum PermissionName {
  CREATE_CHANNELS = 'create_channels',
  DELETE_CHANNELS = 'delete_channels',
  MANAGE_CHANNEL_SETTINGS = 'manage_channel_settings',
  MANAGE_USERS = 'manage_users',
  KICK_USERS = 'kick_users',
  PIN_MESSAGES = 'pin_messages',
  DELETE_MESSAGES = 'delete_messages',
  MANAGE_MESSAGE_REACTIONS = 'manage_message_reactions',
  START_VOICE = 'start_voice',
  KICK_FROM_VOICE = 'kick_from_voice',
  EDIT_SERVER_SETTINGS = 'edit_server_settings',
  MANAGE_RETENTION_POLICY = 'manage_retention_policy',
  MANAGE_ROLES = 'manage_roles',
}
